import { Endereco } from './endereco';
import { UsuarioUnidade } from './usuario-unidade';
import { Consulta } from './consulta';

export class Unidade {

    uuid: string;

    email: string;
    telefone: string;
    endereco: Endereco;
    cor = 'deep-blue';
    permissaoCliente: { id: number };
    tabelaPrecoConsulta: number;
    tipo: number;
    tipoUnidade: any;
    tabelaPrecoTipoLaudo: number;
    unidadePaiRazaoSocial: string;
    inscricaoEstadual: string;
    unidadePai: number;
    logo: string;
    valorConsultoria: number;
    exibirDocumentoConsultas: boolean;
    id: number;
    desabilitado: boolean;
    tokenRg: string;
    idCarsys: string;
    nomeFantasia: string;
    razaoSocial: string;
    documento: string;
    idUnidadePai: number;
    uuidUnidadePai: number;
    gerarNota: string;

    cpf: string;
    cnpj: string;
    tipoDocumento: string = 'CPF';

    alocacaoUnion: string = '';
    status: boolean = true;
    tipoCliente: string = '';
    permissaoConsulta = [];
    tabelaPrecoProdutoConsultoria: string = '';
    listaConsultas = [];
    listaConsultasCredito = [];
    listaConsultasCombinadas = [];

    usuario: UsuarioUnidade;

    constructor(u:any = []) {
        this.email = u['email'] || '';
        this.telefone = u['telefone'] || '';
        this.cor = u['cor'] || 'deep-blue';
        this.permissaoCliente = u['permissaoCliente'] || null;
        this.documento = u['documento'] || '';
        this.tabelaPrecoConsulta = u['idTabelaPrecoConsulta'] || 0;
        this.tipo = u['tipoUnidade'] ? u['tipoUnidade']['id'] : 0 || 0;
        this.tipoUnidade = u['tipoUnidade'] || null;
        this.tabelaPrecoTipoLaudo = u['idTabelaPrecoTipoLaudo'] || 0;
        this.nomeFantasia = u['nomeFantasia'] || '';
        this.unidadePaiRazaoSocial = u['unidadePaiRazaoSocial'] || '';
        this.inscricaoEstadual = u['inscricaoEstadual'] || '';
        this.unidadePai = u['idUnidadePai'] || 0;
        this.uuidUnidadePai = u['uuidUnidadePai'] || 0;
        this.logo = u['logo'] || '';
        this.valorConsultoria = u['valorConsultoria'] || 0.00;
        this.exibirDocumentoConsultas = u['exibirDocumentoConsultas'] || false;
        this.id = u['id'] || null;
        this.uuid = u['uuid']  || null;
        this.razaoSocial = u['razaoSocial'] || '';
        this.desabilitado = u['desabilitado'] || false;
        this.tokenRg = u['tokenRg'] || null;
        this.idCarsys = u['idCarsys'] || null;
        this.gerarNota = u['gerarNota'] || null;

        this.tipoDocumento = this.documento.length > 14 ? 'CNPJ' : 'CPF';
        this.cpf = this.tipoDocumento == 'CPF' ? this.documento : '';
        this.cnpj = this.tipoDocumento == 'CNPJ' ? this.documento : '';

        this.listaConsultas = (u['listaConsultas'] || []).map(c => {
            let consulta = new Consulta(c);
            return consulta;
        });

        this.listaConsultasCredito = (u['listaConsultasCredito'] || []).map(c => {
            let consultaCredito = new Consulta(c);
            return consultaCredito;
        });

        this.listaConsultasCombinadas = (u['listaConsultasCombinadas'] || []).map(r => {
            let consultaCombinada = new Consulta(r);
            return consultaCombinada;
        });

        this.endereco = new Endereco(u['endereco'] || []);
        this.usuario = new UsuarioUnidade(u);

    }


}